import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	isSaving: false,
	saveMessage: "",
	layers: []
};

export default function mapLayers(state = initialState, action) {
	
	switch (action.type) {

		case "IS_FETCHING_GERENCIAR_MAPLAYERS":
			return update(state, { isFetching: { $set: action.bool } });
		
		case "IS_SAVING_GERENCIAR_MAPLAYERS":
			return update(state, { isSaving: { $set: action.bool } });
		
		case "SET_MAP_LAYERS":
			return update(state, { layers: { $set: action.mapLayers } });
		
		case "SET_SAVE_MESSAGE":
			return update(state, { saveMessage: { $set: action.message } });

		case "SET_ONE_MAP_LAYER":
			const _maplayer = state.layers;
			searchAndSetPropertyInListTree(_maplayer, action.id, action.openOrCheck);
			return update(state, { layers: { $set: _maplayer } });
	
		default:
			return state;
	}
}

function searchAndSetPropertyInListTree(element, matchingId, openOrCheck) {
	if (element instanceof Array) {
		for (let elem of element) {
			searchAndSetPropertyInObjectTree(elem, matchingId, openOrCheck);
		}
	} else {
		searchAndSetPropertyInObjectTree(element, matchingId, openOrCheck);
	}
}

function searchAndSetPropertyInObjectTree(element, matchingId, openOrCheck) {
	if (element.id === matchingId) {
		element.openOrCheck = openOrCheck;
	} else if (element.children != null) {
		var i;
		var result = null;
		for (i=0; result == null && i < element.children.length; i++) {
			result = searchAndSetPropertyInObjectTree(element.children[i], matchingId, openOrCheck);
		}
		return result;
	}
	return null;
}



// WEBPACK FOOTER //
// ./src/state/gerenciarMaplayer/reducer.js